module.exports = __webpack_public_path__ + "img/53.4dcba80c.png";